import { Accordion, Box, Container, Heading, Stack, Text } from '@chakra-ui/react';

type FaqItem = {
  question: string;
  answer: string;
};

const faqs: FaqItem[] = [
  {
    question: 'Czy zapisując się na zajęcia podpisuję długoterminową umowę?',
answer: 'Zapisując się na nasze zajęcia podpisujesz jedynie regulamin, który określa zasady korzystania z naszych usług. Nie zobowiązuje Cię on do korzystania z naszych zajęć przez żaden konkretny czas – uczęszczasz na zajęcia tak długo, jak chcesz, z zachowaniem miesięcznego okresu rozliczeniowego.'
  },
  {
    question: 'Czy mogę zrezygnować z zajęć w dowolnym momencie?',
answer: 'Tak, ze wszystkich rodzajów zajęć można zrezygnować w dowolnym momencie, z zachowaniem miesięcznego trybu rozliczenia. W praktyce oznacza to, że np. chcąc zrezygnować z zajęć z końcem stycznia musisz zgłosić nam to najpóźniej 31.01.'
  },
  {
    question: 'W jaki sposób będę rozliczać się za zajęcia?',
answer: 'Zajęcia rozliczane są przelewem na konto, w trybie miesięcznym na podstawie przesłanej mailowo faktury (każdy miesiąc rozliczany jest z góry).'
  },
  {
    question: 'Co w przypadku, gdy nie będę mógł/mogła przyjść na zajęcia, np. z powodu choroby?',
answer: 'Wystarczy zgłosić przez nasz system swoją nieobecność najpóźniej 24 godziny przed ich planowanym rozpoczęciem, a takie zajęcia będzie można odrobić w innym dogodnym terminie.'
  },
];


export const HomeFaq = () => {
  return (
    <Box id="faq" as="section" py={{ base: 10, md: 16 }} bg="gray.50">
      <Container maxW="container.xl">
        <Stack gap={6} align="start">
          <Stack gap={2}>
            <Heading
              as="h2"
              size="lg"
              fontWeight="semibold"
              color="orange.500"
              textTransform="uppercase"
              letterSpacing="widely"
            >
              FAQ
            </Heading>
          </Stack>

          <Accordion.Root collapsible multiple  w="full">
            {faqs.map((faq, index) => (
              <Accordion.Item key={faq.question} value={`item-${index}`}>
                <Accordion.ItemTrigger>
                  <Box flex="1" textAlign="left" py={3}>
                    <Text fontWeight="semibold">{faq.question}</Text>
                  </Box>
                  <Accordion.ItemIndicator />
                </Accordion.ItemTrigger>
                <Accordion.ItemContent>
                  <Accordion.ItemBody pb={4}>
                    <Text color="gray.600">{faq.answer}</Text>
                  </Accordion.ItemBody>
                </Accordion.ItemContent>
              </Accordion.Item>
            ))}
          </Accordion.Root>
        </Stack>
      </Container>
    </Box>
  );
};

export default HomeFaq;
